<style lang="scss" scoped>
.page-system-areasmanage {
    .area-platform-tabs {
        /deep/ .el-tabs__header.is-left {
            min-width: 160px;
        }
        /deep/ .el-tabs__item {
            text-align: left;
        }
        /deep/ .el-tabs__content {
            padding-left: 10px;
        }
    }
    .area-empty-platform {
        padding: 30px 0;
        text-align: center;
        color: #909399;
    }
    .area-city-text {
        display: inline-block;
        line-height: 20px;
        margin-right: 8px;
    }
    .area-city-actions {
        display: inline-block;
        line-height: 1;
        /deep/ .area-city-icon-btn.el-button--mini {
            padding: 3px 5px 0px;
            line-height: 24px;
            text-align: center;
            vertical-align: middle;
        }
        /deep/ .area-city-icon-btn i {
            font-size: 16px;
            line-height: 1;
        }
    }
    .area-city-editor {
        display: flex;
        align-items: center;
        .area-city-cascader {
            width: 260px;
            margin-right: 5px;
        }
    }
}
/deep/ .page-system-areasmanage-dialog {
    max-width: 520px;
    .c-datetime-range {
        max-width: 100% !important;
    }
}
</style>

<template>
    <div class="page-system-areasmanage">
        <!--<div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-button-group class="mrgr5 mrgb5">
                        <el-button type="primary" size="medium" v-for="(item, index) in spiders" :key="index" @click="execSpider(index)">{{ item }}</el-button>
                    </el-button-group>
                </div>
                <div class="clearb"></div>
            </div>
        </div>-->
        <div v-if="allPlatforms.length > 0">
            <el-tabs class="area-platform-tabs" v-model="currentPlatform" tab-position="left" @tab-click="switchPlatform" type="border-card">
                <el-tab-pane v-for="item in allPlatforms" :key="item" :label="item" :name="item">
                    <el-table v-if="currentPlatform === item" :data="tableData" border size="small">
                        <el-table-column label="服务区ID" prop="id"></el-table-column>
                        <el-table-column label="平台名称" prop="platform"></el-table-column>
                        <el-table-column label="服务区名称" prop="name"></el-table-column>
                        <el-table-column label="城市区域" min-width="180">
                            <template slot-scope="scope">
                                <div class="area-city-editor" v-if="manualCityIds.indexOf(scope.row.id) !== -1">
                                    <el-cascader
                                        class="area-city-cascader"
                                        v-model="manualCityCodes[scope.row.id]"
                                        :options="areaOptions"
                                        :props="areaProps"
                                        size="mini"
                                        clearable
                                        filterable
                                        placeholder="请选择城市区域">
                                    </el-cascader>
                                    <el-button type="primary" size="mini"
                                        :loading="cityLoadingIds.indexOf(scope.row.id) !== -1"
                                        @click="saveManualCity(scope.row)">保存</el-button>
                                    <el-button size="mini" @click="cancelManualCity(scope.row)">取消</el-button>
                                </div>
                                <template v-else>
                                    <span class="area-city-text">{{ scope.row.city || "未设置" }}</span>
                                    <div class="area-city-actions">
                                        <el-tooltip effect="dark" :content="scope.row.city ? '重新获取' : '自动获取'" placement="top">
                                            <el-button type="primary" plain size="mini"
                                                class="area-city-icon-btn"
                                                :icon="scope.row.city ? 'el-icon-refresh-left' : 'el-icon-refresh'"
                                                :loading="cityLoadingIds.indexOf(scope.row.id) !== -1"
                                                @click="autoSetCity(scope.row)">
                                            </el-button>
                                        </el-tooltip>
                                        <el-tooltip effect="dark" content="手动选择" placement="top">
                                            <el-button class="area-city-icon-btn" type="warning" plain size="mini" icon="el-icon-mouse" @click="openManualCity(scope.row)"></el-button>
                                        </el-tooltip>
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="小安系统状态" prop="isActive">
                            <template slot-scope="scope">
                                <el-tag type="primary" size="small" v-if="scope.row.isActive">启用</el-tag>
                                <el-tag type="info" size="small" v-else>禁用</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="平台爬虫状态">
                            <template slot-scope="scope">
                                <!--<el-tag type="primary" size="small" v-if="scope.row.isActive">启用</el-tag>
                                <el-tag type="info" size="small" v-else>禁用</el-tag>-->
                                <el-switch class="f12"
                                    v-model="scope.row.enableSpider"
                                    @change="(v) => { setSpiderState(v, scope.row) }"
                                    active-text="启用"
                                    inactive-text="禁用">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="平台显示状态">
                            <template slot-scope="scope">
                                <!--<el-tag type="primary" size="small" v-if="!scope.row.disableShow">显示</el-tag>
                                <el-tag type="info" size="small" v-else>隐藏</el-tag>-->
                                <el-switch class="f12"
                                    v-model="scope.row.disableShow"
                                    @change="(v) => { setDisableShow(v, scope.row) }"
                                    active-text="显示" :active-value="false"
                                    inactive-text="隐藏" :inactive-value="true">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="更新时间" prop="updatedAt"></el-table-column>
                        <el-table-column label="操作" width="205px" align="right" v-if="false">
                            <template slot-scope="scope">
                                <!--<el-dropdown trigger="click" v-if="scope.row.isActive">
                                    <el-button class="mrgr5" type="warning" plain size="mini">运行爬虫<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(spiderItem, index) in spiders" :key="spiderItem" v-show="index > 0"
                                            @click.native="execSpider(index, scope.row)">{{ spiderItem }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>-->
                                <el-button type="info" plain size="mini" v-if="scope.row.enableSpider" @click.native="setStatus(scope.row)">设为禁用</el-button>
                                <el-button type="primary" plain size="mini" v-else @click.native="setStatus(scope.row)">设为启用</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="area-empty-platform" v-else>
            暂无平台数据
        </div>
        <!--爬虫-->
        <spider :ref="refSpider"></spider>
    </div>
</template>

<script>
import * as funAll from "@/api/all"
import * as funSpider from "@/api/spider"
import moment from "moment"
import spider from "./components/spider"
export default {
    name: "pageSystemAreasManage",
    components: { spider },
    data() {
        return {
            refSpider: "refAreasManageToSpider",
            listQuery: {
                platform: "",
                isActive: null
            },
            tableData: [],
            allPlatforms: [],
            currentPlatform: "",
            curClickSpider: 0,
            allAreas: [],
            showDialog: false,
            dialogData: {
                areas: [],
                beginDate: "",
                endDate: ""
            },
            formRefName: "refAreasManageDialog",
            spiders: ["重爬所有服务区", "重爬站点", "重爬订单", "重爬挪车任务", "重爬钱包", "重爬用户", "重爬车辆日志"],
            selectedTime: [],
            amap: null,
            geocoder: null,
            cityLoadingIds: [],
            manualCityIds: [],
            manualCityCodes: {},
            areaOptions: [],
            allAreasData: [],
            areaProps: { value: "value", label: "label", children: "children", checkStrictly: true }
        }
    },
    mounted() {
        this.loadAreaData()
        this.queryAllPlatforms()
    },
    methods: {
        async queryAllPlatforms() {
            await funAll.AllPlatforms().then(res => {
                this.allPlatforms = res || []
                if (this.allPlatforms.length > 0 && !this.currentPlatform) {
                    this.currentPlatform = this.allPlatforms[0]
                    this.getDataList()
                }
            })
        },
        getDataList() {
            window.$common.fullLoading()
            this.listQuery.platform = this.currentPlatform || ""
            funAll.AllServiceAreas(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                this.tableData = response || []
                this.allAreas = this.tableData.filter(x => x.isActive)
            }).catch(() => {
                this.tableData = []
                this.allAreas = []
                window.$common.closeFullLoading()
            })
        },
        switchPlatform(tab) {
            this.currentPlatform = tab.name
            this.getDataList()
        },
        async loadAreaData() {
            try {
                const areasResponse = await fetch('/configs/pca-code.json')
                this.allAreasData = await areasResponse.json()
                this.areaOptions = this.buildAreaOptions(this.allAreasData)
            } catch (error) {
                console.error("加载省市区数据失败:", error)
                this.areaOptions = []
            }
        },
        buildAreaOptions(areas) {
            return (areas || []).map(item => {
                let option = {
                    value: item.code,
                    label: item.name
                }
                if (item.children && item.children.length > 0) {
                    option.children = this.buildAreaOptions(item.children)
                }
                return option
            })
        },
        async autoSetCity(row) {
            if (!row || !row.id) {
                this.warningMsg("服务区数据错误!")
                return false
            }
            if (!row.centerLng || !row.centerLat) {
                this.warningMsg("缺少服务区中心点经纬度，请手动选择城市区域!")
                this.openManualCity(row)
                return false
            }
            this.setCityLoading(row.id, true)
            try {
                const cityInfo = await this.getCityInfoByLngLat(row.centerLng, row.centerLat)
                if (!cityInfo.city || !cityInfo.cityCode) {
                    this.warningMsg("未解析到有效的城市区域!")
                    return false
                }
                await funAll.UpdateServiceAreaCity({
                    id: row.id,
                    city: cityInfo.city,
                    cityCode: cityInfo.cityCode
                })
                row.city = cityInfo.city
                row.cityCode = cityInfo.cityCode
                this.successMsg("城市区域已更新!")
            } catch (e) {
                console.error("自动获取城市区域失败:", e)
                this.warningMsg("自动获取城市区域失败，请手动选择!")
                this.openManualCity(row)
            } finally {
                this.setCityLoading(row.id, false)
            }
        },
        setCityLoading(id, isLoading) {
            const index = this.cityLoadingIds.indexOf(id)
            if (isLoading && index === -1) {
                this.cityLoadingIds.push(id)
            } else if (!isLoading && index !== -1) {
                this.cityLoadingIds.splice(index, 1)
            }
        },
        async getCityInfoByLngLat(lng, lat) {
            await this.initGeocoder()
            return new Promise((resolve, reject) => {
                this.geocoder.getAddress([Number(lng), Number(lat)], (status, result) => {
                    if (status === "complete" && result && result.regeocode) {
                        const address = result.regeocode.addressComponent || {}
                        const city = this.getFullCityName(address)
                        const cityCode = address.adcode || ""
                        resolve({ city, cityCode })
                    } else {
                        reject(result)
                    }
                })
            })
        },
        initGeocoder() {
            if (this.geocoder) {
                return Promise.resolve(this.geocoder)
            }
            return new Promise((resolve, reject) => {
                this.mxLoadGaoDeMap({ plugins: ["AMap.Geocoder"] }, AMap => {
                    this.amap = AMap
                    this.geocoder = new AMap.Geocoder()
                    resolve(this.geocoder)
                }, reject)
            })
        },
        getAddressName(val) {
            if (Array.isArray(val)) {
                return val[0] || ""
            }
            return val || ""
        },
        getFullCityName(address) {
            const province = this.getAddressName(address.province)
            const city = this.getAddressName(address.city)
            const district = this.getAddressName(address.district)
            return [province, city, district].filter((item, index, arr) => {
                return item && arr.indexOf(item) === index
            }).join("")
        },
        async openManualCity(row) {
            if (!this.areaOptions || this.areaOptions.length === 0) {
                await this.loadAreaData()
            }
            if (this.manualCityIds.indexOf(row.id) === -1) {
                this.manualCityIds.push(row.id)
            }
            let codes = []
            if (row.cityCode) {
                codes = this.findCodePath(this.areaOptions, String(row.cityCode))
            }
            this.$set(this.manualCityCodes, row.id, codes)
        },
        cancelManualCity(row) {
            const index = this.manualCityIds.indexOf(row.id)
            if (index !== -1) {
                this.manualCityIds.splice(index, 1)
            }
            this.$delete(this.manualCityCodes, row.id)
        },
        async saveManualCity(row) {
            const codes = this.manualCityCodes[row.id] || []
            if (!codes || codes.length === 0) {
                this.warningMsg("请选择城市区域!")
                return false
            }
            const city = this.getAreaNameByCodes(codes)
            const cityCode = String(codes[codes.length - 1])
            this.setCityLoading(row.id, true)
            try {
                await funAll.UpdateServiceAreaCity({
                    id: row.id,
                    city,
                    cityCode
                })
                row.city = city
                row.cityCode = cityCode
                this.cancelManualCity(row)
                this.successMsg("城市区域已更新!")
            } catch(e) {
                console.error("保存城市区域失败:", e)
                this.errorMsg("保存城市区域失败!")
            } finally {
                this.setCityLoading(row.id, false)
            }
        },
        findCodePath(options, code, path) {
            path = path || []
            for (let i in options) {
                const item = options[i]
                const currentPath = path.concat(item.value)
                if (String(item.value) === String(code)) {
                    return currentPath
                }
                if (item.children && item.children.length > 0) {
                    const childPath = this.findCodePath(item.children, code, currentPath)
                    if (childPath.length > 0) {
                        return childPath
                    }
                }
            }
            return []
        },
        getAreaNameByCodes(codes) {
            let names = []
            let currentOptions = this.areaOptions
            for (let i in codes) {
                const code = codes[i]
                const item = currentOptions.find(x => x.value === code)
                if (!item) {
                    break
                }
                names.push(item.label)
                currentOptions = item.children || []
            }
            return names.join("")
        },
        execSpider(index, row) {
            let name = this.spiders[index]
            this.curClickSpider = index
            if (row && row.name) {
                this.dialogData.areas = [row.name]
            }
            this.confirm(`确定要${name}吗？`).then(()=>{
                if (name === this.spiders[0]) {
                    // 所有服务区
                    funSpider.execServiceAreaSpider().then(() => {
                        this.commonSuccess()
                    })
                } else {
                    this.openParams()
                }
            })
        },
        openParams() {
            // this.showDialog = true
            let params = {
                areas: [],
                index: this.curClickSpider,
            }
            this.$refs[this.refSpider].open(params)
        },
        setSpiderState(val, row) {
            window.$common.fullLoading()
            funAll.UpdateAreasActive({ id: row.id, enableSpider: val, disableShow: row.disableShow }).then(() => {
                window.$common.closeFullLoading()
            }).catch(() => {
                row.enableSpider = false
            })
        },
        setDisableShow(val, row) {
            window.$common.fullLoading()
            funAll.UpdateAreasActive({ id: row.id, enableSpider: row.enableSpider, disableShow: val }).then(() => {
                window.$common.closeFullLoading()
                this.$store.dispatch('setServiceAreas')
            }).catch(() => {
                row.disableShow = false
            })
        },
        setStatus(row) {
            let txt = row.isActive ? "禁用" : "启用"
            this.confirm(`确定要${txt}“${row.name}”服务区吗？`).then(()=>{
                window.$common.fullLoading()
                funAll.UpdateAreasActive({ id: row.id, enableSpider: !row.enableSpider }).then(() => {
                    location.reload()
                })
            })
        },
        commonSuccess() {
            this.successMsg("爬虫已运行，请稍后查看数据是否正确!")
        }
    }
}
</script>
